import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import noop from '../../utils/noop';

import { getMessage } from '@a0/support-center-common/lib/getMessage';

import '../ReactSelect/styles.css';

class TenantClientsControl extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.fieldValue };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(options) {
    const { fieldName, changeFieldValue, changeCallback } = this.props;

    this.setState({ value: options });

    changeFieldValue(fieldName, options ? options.map(this.mapOptions) : []);
    changeCallback(options || null);
  }

  mapOptions(option) {
    return {
      id: option && option.value,
      name: option && option.label
    };
  }

  render() {
    const { name, autoFocus, disabled, options, className } = this.props;

    return (
      <Select
        placeholder={getMessage('ALL_CLIENTS')}
        className={className}
        autofocus={autoFocus}
        name={name}
        inputProps={{ id: name, autoComplete: 'off' }}
        value={this.state.value}
        options={options}
        onChange={this.handleChange}
        cache={false}
        disabled={disabled}
        multi
      />
    );
  }
}

TenantClientsControl.propTypes = {
  name: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  changeFieldValue: PropTypes.func.isRequired,
  changeCallback: PropTypes.func,
  className: PropTypes.string,
  fieldValue: PropTypes.array,
  options: PropTypes.array,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool
};

TenantClientsControl.defaultProps = {
  fieldName: '',
  fieldValue: [],
  changeFieldValue: noop,
  changeCallback: noop
};

export default TenantClientsControl;
